export default [
  {
    text: 'Work',
    name: 'work-main',
  },
  {
    text: 'Matter',
    name: 'matter-main',
  },
  {
    text: "About",
    name: 'L2',
    params: {
      slug: 'about',
    },
  },
  {
    text: 'Contact',
    name: 'contact-main',
  },
];



// WEBPACK FOOTER //
// ./src/data/snippets/nav.js